"use client"

import { useEffect } from "react"

import { AnalyticsEvent, track } from "@/lib/analytics"
import { bootcampCtaFor } from "@/lib/analytics/bootcamp-cta"

// The ONE listener that measures /bootcamp's buttons. The sections are shared
// modules (hero, pricing cards, dates, closing band) that other pages render
// too, so nothing is wired into them: this leaf, mounted once by the page,
// listens at the document and reads each click's link back. A click outside
// the page's own `.bootcamp-mock` root (the masthead, the footer, the sticky
// bar) is not this page's button and is ignored. Renders nothing.
//
// Each click fires `bootcamp_cta_clicked` with `cta` (which button, named in
// lib/analytics/bootcamp-cta.ts), `module` (the section it sits in: the
// ModuleSlot's instance id) and, on a checkout link, `plan` and `weekend`.
export function BootcampClickTracking() {
  useEffect(() => {
    const onClick = (event: MouseEvent) => {
      const target = event.target
      if (!(target instanceof Element)) return
      const anchor = target.closest("a[href]")
      if (!(anchor instanceof HTMLAnchorElement) || !anchor.closest(".bootcamp-mock")) return

      const click = bootcampCtaFor(anchor.getAttribute("href") ?? "", anchor.className)
      if (!click) return
      const section = anchor.closest("[data-module-instance]")?.getAttribute("data-module-instance")
      track(AnalyticsEvent.BootcampCtaClicked, {
        cta: click.cta,
        href: click.href,
        page_path: "/bootcamp",
        ...(click.plan ? { plan_id: click.plan } : {}),
        ...(click.weekend ? { weekend: click.weekend } : {}),
        ...(section ? { module: section } : {}),
      })
    }
    document.addEventListener("click", onClick)
    return () => document.removeEventListener("click", onClick)
  }, [])

  return null
}
